/* eslint-disable import/no-anonymous-default-export */
export default {
  title: 'Tucker Tub Pet Food',
  description: 'Tucker Tub is the greatest pet food company in the world',
  openGraph: {
    type: 'website',
    locale: 'en_AU',
    url: 'https://google.com',
    site_name: 'Tucker Tub Pet Food',
    title: 'Tucker Tub Pet Food',
    description: 'Tucker Tub Pet Food is the greatest pet food company in the world',
    images: [
      {
        url: '/assets/icons/logo_text.svg',
        width: 1200,
        height: 1200,
        alt: 'Tucker Tub Pet Food'
      }
    ]
  }
}
